import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, forkJoin, Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { Department } from "@ui-components/models";
import { DataSourcesService } from "./data-sources.service";

@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {
  private departmentsSubject = new BehaviorSubject<Department[]>(null);
  departments$: Observable<Department[]> = this.departmentsSubject.asObservable();

  private employeesSubject = new BehaviorSubject<any[]>(null);
  employees$: Observable<any[]> = this.employeesSubject.asObservable();

  constructor(
    private http: HttpClient,
    private dataSourceService: DataSourcesService) {
      
    }

  getAll(deptApiId, empApiId) {
    let arr = [];
    this.departments$.pipe(take(1)).subscribe((res) => (arr = res));
    if (arr && arr.length > 0) { return; };

    let deptDataObj = {
      ID: "1",
      CRG_COM_ID: "1",
      inputType: ["ID", "CRG_COM_ID"]
    };
    let empsDataObj = {
      CompanyId: "1",
      PageNumber: "1",
      nBranch: "1",
      EmployeeStatus: "2",
      inputType: ["CompanyId", "PageNumber", "nBranch", "EmployeeStatus"]
    };

    const departmentsRequest = this.dataSourceService.invokeDataSource(deptApiId, deptDataObj);

    const employeesRequest = this.dataSourceService.invokeDataSource(empApiId, empsDataObj);

    forkJoin([departmentsRequest, employeesRequest])
      .pipe(
        map((res: any[]) => {
          const departments: Department = res[0].content;
          const employees = res[1].Data;
          return [departments, employees]
        })
      )
      .subscribe(
        (res) => {
          this.departmentsSubject.next(res[0]);
          this.employeesSubject.next(res[1]);

          // console.log('by wael', res)
        }
      );
  }


  // helper methods
  getEmployeeByID(coreUsername: string) {
    if (!coreUsername) {
      coreUsername = localStorage.getItem('coreUsername');
      if (!coreUsername)
        return;
    }

    let employees;
    this.employees$.pipe(take(1)).subscribe(res => employees = res);

    if (!employees) { return; }
    const target = employees.find((emp: any) => {
      if (!emp.USERNAME) {
        emp.USERNAME = emp.NAME.split(' ')[0];
      }
      return emp.USERNAME.toLowerCase() === coreUsername.toLowerCase()
    });
    if (!target) { return; }
    return target;
  }

  shortName(name: string) {
    if (!name) { return; }
    const nameArr = name.split(' ').filter(x => x.length > 0);
    return `${nameArr[0]} ${nameArr[nameArr.length - 1]}`
  }

  isBookingCreator(creator: any){
    if(!creator) { return false; }

    const activeUser = JSON.parse(localStorage.getItem('userData'));
    if(!activeUser) { return false; }

    return activeUser['username'].toLowerCase() === creator.USERNAME.toLowerCase();
  }


}
